import { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Card, Typography, Button, Dialog, DialogActions, DialogContent,
  DialogContentText, DialogTitle, CircularProgress
} from "@mui/material";
import { FaTrash } from "react-icons/fa";
import SnackbarAlert from "../../Reusbale/SnackbarAlert";
import COLORS from "../../../../../constants/colors";
import baseURL from "../../config";
import { toast } from "react-toastify";

const AccountActions = () => {
  const [openDialog, setOpenDialog] = useState(false);
  const [loading, setLoading] = useState(false);
  const [snackbar, setSnackbar] = useState({ open: false, message: "", severity: "info" });
  const navigate = useNavigate();

  const handleOpenDialog = () => {
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    if (!loading) {
      setOpenDialog(false);
    }
  };

  const handleCloseSnackbar = () => {
    setSnackbar({ ...snackbar, open: false });
  };

  const handleConfirmDelete = async () => {
    setLoading(true);
    try {
      const response = await fetch(`${baseURL}/user/request-deletion`, {
        method: "POST",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
      });

      const data = await response.json();

      if (response.ok) {
       
        toast.success('Account deletion request submitted successfully!');
        // Wait a moment before logging out
        setTimeout(() => {
          // Clear cookie and redirect
          navigate("/user/login"); // Adjust route if your logout logic is different
        }, 2000);
      } else {
        

        toast.error(data.message || "Something went wrong. Please try again.");

      }
    } catch (error) {
      console.error("Error deleting account:", error);
      

        toast.error("Failed to delete account. Please try again later.");

      
    }

    setLoading(false);
    setOpenDialog(false);
  };

  return (
    <>
      <Card
        sx={{
          p: 2,
          borderRadius: 2,
          bgcolor: "#fff",
          boxShadow: 0,
          textAlign: "left",
          border: `1px solid ${COLORS.warning}`,
        }}
      >
        <Typography
          variant="h6"
          fontWeight="bold"
          sx={{ color: COLORS.primary, mb: 2, display: "flex", alignItems: "center" }}
        >
          <FaTrash style={{ marginRight: 8 }} />
          Account Management
        </Typography>

        <Typography
          variant="body2"
          sx={{
            color: "#C07600",
            fontWeight: "bold",
            mb: 2,
            border: `1px solid ${COLORS.warning}`,
            borderRadius: "5px",
            padding: "8px",
            backgroundColor: "#fff8e1",
          }}
        >
          Warning: Account Deletion removes all your data
        </Typography>

        <Typography variant="body2" sx={{ color: "#666", mb: 2 }}>
           This action is <strong>irreversible</strong>.
          You will receive an <strong>email notification</strong> once your request is approved.
          After submitting this request, you will be automatically logged out.
        </Typography>

        <Button
          variant="contained"
          color="error"
          sx={{
            textTransform: "none",
            borderRadius: 2,
            boxShadow: 0,
          }}
          onClick={handleOpenDialog}
        >
          Delete Account
        </Button>

        {/* Confirmation Dialog */}
        <Dialog
          open={openDialog}
          onClose={handleCloseDialog}
          sx={{
            "& .MuiDialog-paper": {
              borderRadius: 3,
              padding: 2,
            },
          }}
        >
          <DialogTitle sx={{ fontWeight: "bold", color: COLORS.warning }}>
            Confirm Account Deletion
          </DialogTitle>
          <DialogContent>
            <DialogContentText sx={{ color: "#444", textAlign: "center", fontSize: "0.95rem" }}>
              Are you sure you want to delete your account? This action is <strong>permanent</strong>.<br />
              All your data will be deleted after <strong>admin approval</strong>, and you’ll be logged out.
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={handleCloseDialog}
              color="secondary"
              sx={{ textTransform: "none", boxShadow: 0 }}
              disabled={loading}
            >
              Cancel
            </Button>
            <Button
              onClick={handleConfirmDelete}
              color="error"
              variant="contained"
              sx={{ textTransform: "none", boxShadow: 0, minWidth: 120 }}
              disabled={loading}
            >
              {loading ? (
                <>
                  <CircularProgress size={20} sx={{ color: "#fff", marginRight: 1 }} />
                  Please wait...
                </>
              ) : (
                "Confirm Delete"
              )}
            </Button>
          </DialogActions>
        </Dialog>
      </Card>

      {/* Snackbar for feedback messages */}
      <SnackbarAlert
        open={snackbar.open}
        message={snackbar.message}
        severity={snackbar.severity}
        handleClose={handleCloseSnackbar}
      />
    </>
  );
};

export default AccountActions;
